// Ported from CarbonEngine (MIT, (c) 2026 CCP Games) - https://github.com/carbonengine/trinity
//   audio/src/AudEventKey.h
// Generated by format-carbon carbon-class --emit. Verify against audio/AudEventKey.json.
import { io, type } from "@carbonenginejs/runtime-utils/schema";
import { CjsModel } from "@carbonenginejs/runtime-utils/model";

/** AudEventKey (audio) - generated from schema shapeHash 54ef4422.... */
@type.define({ className: "AudEventKey", family: "audio" })
export class AudEventKey extends CjsModel
{

  /** m_value (std::wstring) [READWRITE, PERSIST] */
  @io.persist
  @type.string
  value = "";

  /** m_time (float) [READWRITE, PERSIST] */
  @io.persist
  @type.float32
  time = 0;

}
